import { createContext } from 'react';

const CompletedProjectContext = createContext(void 0);

CompletedProjectContext.displayName = 'CompletedProjectContext';

export default CompletedProjectContext;